export class HrPerEvaluationPathDefinitionKey {
    private static readonly keyPrefix = 'hrPerEvaluationPathDef';
    public static title = `${HrPerEvaluationPathDefinitionKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerEvaluationPathDefinitionKey.keyPrefix}.pageHeader`;

    public static objectNumber = `${HrPerEvaluationPathDefinitionKey.keyPrefix}.objectNumber`;
    public static confirmationStep = `${HrPerEvaluationPathDefinitionKey.keyPrefix}.confirmationStep`;
    public static step = `${HrPerEvaluationPathDefinitionKey.keyPrefix}.step`;
    public static process = `${HrPerEvaluationPathDefinitionKey.keyPrefix}.process`;
    public static processes = `${HrPerEvaluationPathDefinitionKey.keyPrefix}.processes`;
    public static nextStep = `${HrPerEvaluationPathDefinitionKey.keyPrefix}.nextStep`;
    public static details = `${HrPerEvaluationPathDefinitionKey.keyPrefix}.details`;
}
